export default __webpack_public_path__ + "b96ae28fa238fde4038f4573acfea0b0.png";